import { anim, prog, stagger } from '../../../../motion'
import { Fit, Line } from '../../../../v2/kit'
import { LINKS } from '../../../bewerbende/copy'
import { useCopy } from '../../../i18n'
import { toTop } from '../../../kit'
import geschafft from '../../media/app-geschafft.jpg'
import staerken from '../../media/app-staerken.jpg'
import hochstaplerPoster from '../../media/game-hochstapler.jpg'
import hochstapler from '../../media/game-hochstapler.mp4'
import { Magnetic, MaskText, ScrollVideo } from '../../stage/fx'

export const APP_PARTICLES = [
  [
    0.04,
    (w, h, narrow) => ({
      type: 'sphere',
      x: narrow ? w / 2 : w * 0.7,
      y: narrow ? h * 0.72 : h * 0.52,
      r: narrow ? w * 0.48 : Math.min(h * 0.46, w * 0.26)
    })
  ],
  [
    0.96,
    (w, h, narrow) => ({
      type: 'sphere',
      x: narrow ? w / 2 : w * 0.7,
      y: narrow ? h * 0.72 : h * 0.52,
      r: narrow ? w * 0.48 : Math.min(h * 0.46, w * 0.26)
    })
  ]
]

// Drei Smartphones fächern sich auf, Bewertungen ziehen in eigenem Tempo vorbei
const PHONES = [
  { img: geschafft, fan: -1 },
  { video: hochstapler, poster: hochstaplerPoster, fan: 0 },
  { img: staerken, fan: 1 }
]
const REVIEWS = [
  { at: [0.1, 0.62], x: -48, y: 10, travel: 60 },
  { at: [0.16, 0.7], x: 8, y: 34, travel: 80 },
  { at: [0.22, 0.78], x: -42, y: 66, travel: 100 }
]
const NARROW = { maxW: 0.9, maxH: 0.42 }

export default function CsApp() {
  const c = useCopy('app')

  return (
    <div className='sc-full'>
      <div className='cs-app__text'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='sc-h2'>
          <MaskText text={c.title} at={[0.02, 0.14]} />
        </h2>
        <Line at={[0.12, 0.18]} y={20} className='sc-lead'>
          {c.text}
        </Line>
        <div className='cs-stores' style={anim({ at: [0.18, 0.24], y: 20 })}>
          <Magnetic
            href={LINKS.appStore}
            target='_blank'
            rel='noreferrer'
            className='cs-store'
          >
            <small>{c.appStore[0]}</small>
            {c.appStore[1]}
          </Magnetic>
          <Magnetic
            href={LINKS.googlePlay}
            target='_blank'
            rel='noreferrer'
            className='cs-store'
          >
            <small>{c.googlePlay[0]}</small>
            {c.googlePlay[1]}
          </Magnetic>
        </div>
      </div>

      <div className='cs-app__stage'>
        <Fit
          w={760}
          h={640}
          maxW={0.8}
          maxH={0.64}
          narrow={NARROW}
          className='cs-fan-fit'
        >
          <div className='cs-fan' style={prog([0.04, 0.3])}>
            {PHONES.map((p, i) => (
              <div
                key={i}
                className='cs-fan__phone'
                style={{ '--f': p.fan, '--z': p.fan === 0 ? 1 : 0 }}
              >
                <div className='sc-phone'>
                  <div className='sc-phone__screen'>
                    {p.video ? (
                      <ScrollVideo
                        src={p.video}
                        poster={p.poster}
                        at={[0.02, 1]}
                      />
                    ) : (
                      <img src={p.img} alt='' />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Fit>

        {c.reviews.map((r, i) => (
          <figure
            key={r.who}
            className='cs-review sc-glass'
            style={{
              '--rx': `${REVIEWS[i].x}%`,
              '--ry': `${REVIEWS[i].y}%`,
              ...prog(REVIEWS[i].at),
              transform: `translateY(calc((1 - var(--p)) * ${REVIEWS[i].travel}cqh * var(--motion)))`,
              opacity: 'clamp(0, var(--p) * 4, 1)'
            }}
          >
            <div className='cs-review__stars' aria-hidden='true'>
              ★★★★★
            </div>
            <blockquote>{r.quote}</blockquote>
            <figcaption>{r.who}</figcaption>
          </figure>
        ))}
      </div>

      <footer
        className='cs-footer'
        style={anim({ at: stagger(0.86, 0, 0.06, 0), y: 20 })}
      >
        <a href={LINKS.privacy} target='_blank' rel='noreferrer'>
          {c.privacy}
        </a>
        <a href={LINKS.imprint} target='_blank' rel='noreferrer'>
          {c.imprint}
        </a>
        <button type='button' onClick={toTop}>
          {c.top}
        </button>
      </footer>
    </div>
  )
}
